'use strict';

var React = require('react');
var fontawesomeSvgCore = require('@fortawesome/fontawesome-svg-core');
var PropTypes = require('prop-types');
var semanticUiReact = require('semantic-ui-react');
var index = require('./index-012e579f.js');
var index$2 = require('./index-ec9d2b69.js');
var index$1 = require('./index-506bb7ce.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded$1 = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded$1);

  mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = process.env.NODE_ENV === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (fontawesomeSvgCore.parse.icon) {
    return fontawesomeSvgCore.parse.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}

var _excluded = ["forwardedRef"];
function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? fontawesomeSvgCore.parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = fontawesomeSvgCore.icon(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: PropTypes__default["default"].bool,
  border: PropTypes__default["default"].bool,
  beatFade: PropTypes__default["default"].bool,
  bounce: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].string,
  fade: PropTypes__default["default"].bool,
  flash: PropTypes__default["default"].bool,
  mask: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].array, PropTypes__default["default"].string]),
  maskId: PropTypes__default["default"].string,
  fixedWidth: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  flip: PropTypes__default["default"].oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].array, PropTypes__default["default"].string]),
  listItem: PropTypes__default["default"].bool,
  pull: PropTypes__default["default"].oneOf(['right', 'left']),
  pulse: PropTypes__default["default"].bool,
  rotation: PropTypes__default["default"].oneOf([0, 90, 180, 270]),
  shake: PropTypes__default["default"].bool,
  size: PropTypes__default["default"].oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes__default["default"].bool,
  spinPulse: PropTypes__default["default"].bool,
  spinReverse: PropTypes__default["default"].bool,
  symbol: PropTypes__default["default"].oneOfType([PropTypes__default["default"].bool, PropTypes__default["default"].string]),
  title: PropTypes__default["default"].string,
  titleId: PropTypes__default["default"].string,
  transform: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),
  swapOpacity: PropTypes__default["default"].bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React__default["default"].createElement);

const faArrowRight = {
  prefix: 'fas',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
};
const faArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};

function ExpandCollapseButton(props) {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("button", {
    className: "ui sv todo-button expdClps",
    style: {
      marginLeft: "0px",
      marginRight: "auto",
      cursor: "pointer"
    },
    onClick: (e, direction, ref, delta, position, dragGrid) => {
      if (props.expandIsfFormWidth) {
        window.dispatchEvent(new Event("resize"));
        setTimeout(() => {
          props.toggleExpandIsfFormWidth(props.expandIsfFormWidth); // Still takes 20 ms, but now runs once in 100 ms
        }, 0);
      } else {
        props.toggleExpandIsfFormWidth(props.expandIsfFormWidth);
        setTimeout(() => {
          window.dispatchEvent(new Event("resize")); // Still takes 20 ms, but now runs once in 100 ms
        }, 1000);
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(FontAwesomeIcon, {
    className: "cardItem fa-icon",
    icon: props.expandIsfFormWidth ? faArrowRight : faArrowLeft,
    style: {
      color: "#318192",
      fontSize: "10px"
    }
  })));
}

function BackToPoolButton(props) {
  var _props$kxUser, _props$kxUser$userBas;
  const shipId = props.shipId;
  (_props$kxUser = props.kxUser) === null || _props$kxUser === void 0 ? void 0 : (_props$kxUser$userBas = _props$kxUser.userBasicInfo) === null || _props$kxUser$userBas === void 0 ? void 0 : _props$kxUser$userBas.userGuid;
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const {
    translate
  } = props;
  //console.log("eeeeeeeeee",props);
  const onClickHandler = async () => {
    props.toggleLoaderFunc();
    await index.bhSurrender(shipId);
    props.toggleLoaderFunc("Please wait!!");
    setButtonLoader(true);
    props.searchByID(props.shipId);
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    id: "backtopool",
    size: "mini",
    key: "BACK_TO_POOL",
    disabled: false,
    className: "sv todo-button primaryBtn",
    onClick: e => {
      e.stopPropagation();
      setButtonLoader(true);
      onClickHandler();
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    style: {
      color: "#318192",
      fontSize: "13px"
    },
    name: "undo"
  }), buttonLoader ? translate("LOADING") + "..." : translate("BACK_TO_POOL"));
}

function TakeOverButton(props) {
  const shipId = props.shipId;
  const userGuid = index.lodash_2(props.kxUser, 'userBasicInfo.userGuid', '');
  props.currentJobState;
  const {
    translate
  } = props;
  const label = translate(props.label) || translate("TAKE_OVER");
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const onClickHandler = async () => {
    props.toggleLoaderFunc();
    let conf = window.confirm("Are you sure to take over this shipment?");
    if (conf) {
      await setButtonLoader(true);
      await index.bhSurrender(shipId).then(async response => {
        index.sendMsgToRocketChat(shipId, 14, userGuid);
        index.startBhHouseJob(props.shipId, "BH_BROKER_ASSIGNED", userGuid).then(async res => {
          index.startBhHouseJob(props.shipId, "BH_BROKER_IN_PROCESS", userGuid).then(async res => {
            index.sendMsgToRocketChat(props.shipId, 13, userGuid);
          });
        });
      }).then(async () => {
        await props.toggleLoaderFunc("Please wait!!");
        if (props.currentEntryState === "STATE_ENTRY_ON_HOLD") {
          await index.updateWorkFlow(shipId, "ENTRY_IN_PROCESS", userGuid);
        }
        await props.toggleLoaderFunc("Please wait!!");
        await props.searchByID(shipId);
      });
    }
    await props.toggleLoaderFunc("Please wait!!");
    await setButtonLoader(false);
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    size: "mini",
    key: "TAKE_OVER",
    disabled: false,
    className: "sv todo-button primaryBtn",
    onClick: e => {
      e.stopPropagation();
      setButtonLoader(true);
      onClickHandler();
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    style: {
      color: "#318192",
      fontSize: "13px"
    },
    name: "undo"
  }), buttonLoader ? " LOADING..." : label);
}

const reviewFailedResponse = response => {
  var _response$data, _response$data$eventM, _Object$entries, _response$data2;
  if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$eventM = _response$data.eventMessage) === null || _response$data$eventM === void 0 ? void 0 : _response$data$eventM.code) === 400) {
    index.showToast('Internal Server Error');
    return [''];
  }
  return ((_Object$entries = Object.entries(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.eventMessage)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.reduce((prev, curr = []) => {
    var _curr$;
    const failedMessageTypeList = curr === null || curr === void 0 ? void 0 : (_curr$ = curr[1]) === null || _curr$ === void 0 ? void 0 : _curr$.filter(itm => (itm === null || itm === void 0 ? void 0 : itm.fieldmessageType) === 'FAIL');
    return [...prev, ...failedMessageTypeList];
  }, [])) || [];
};
const ReviewEntryButton = props => {
  var _props$kxUser, _props$kxUser$userBas;
  const shipId = props.shipId;
  const toggleLoaderFunc = props.toggleLoaderFunc;
  const dispatch = index.useDispatch();
  const formType = props.formType;
  const brokerGuid = (_props$kxUser = props.kxUser) === null || _props$kxUser === void 0 ? void 0 : (_props$kxUser$userBas = _props$kxUser.userBasicInfo) === null || _props$kxUser$userBas === void 0 ? void 0 : _props$kxUser$userBas.userGuid;
  index.useSelector(state => state);
  const {
    translate,
    version,
    serviceType
  } = props;
  const isImportShipment = serviceType === 'IMPORT';
  const transmissionType = index.useSelector(index$1.selectTransmissionType);

  //const setReviewSuccessfully = props.setReviewSuccessfully;

  const reviewClickHandler = async (shipId, formType) => {
    var _reviewFailedErrors;
    let frmType = formType.replace('_WRITE', '');
    toggleLoaderFunc(`Reviewing ${frmType} Form...`, 1000);
    let response = null;
    let fieldMessage = [];
    let reviewFailedErrors = [];
    if (window.shipmentCountry === 'GB') {
      var _response, _response$data3;
      await toggleLoaderFunc(`Reviewing ${frmType} Form...`, 1000);
      response = await index.reviewJob('VALIDATE_REQUEST', {
        shipmentId: shipId,
        countryCode: window.shipmentCountry
      });
      reviewFailedErrors = reviewFailedResponse(response) || [];
      dispatch({
        type: 'INITIALIZE_SERVER_ERRORS_TREE',
        payload: ((_response = response) === null || _response === void 0 ? void 0 : (_response$data3 = _response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.eventMessage) || {}
      });
    } else if (['ES', 'NL'].includes(window.shipmentCountry) && ['AES', 'DMS'].includes(version) && serviceType === 'EXPORT' || version === 'DMS' && serviceType === 'IMPORT') {
      var _response2, _response2$data, _response2$data$event, _response3, _response3$data;
      await index.reviewJob(`SUBMIT_FORM_${window.shipmentCountry}`, {
        shipmentId: shipId,
        version,
        countryCode: window.shipmentCountry,
        serviceType
      });
      await toggleLoaderFunc(`Reviewing ${frmType} Form...`, 1000);
      response = await index.reviewJob('VALIDATE_REQUEST', {
        shipmentId: shipId,
        countryCode: window.shipmentCountry,
        formType: ['DMS'].includes(version) ? formType : ''
      });
      reviewFailedErrors = reviewFailedResponse(response) || [];
      response = ((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : (_response2$data$event = _response2$data.eventMessage) === null || _response2$data$event === void 0 ? void 0 : _response2$data$event.code) !== 400 ? (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$data = _response3.data) === null || _response3$data === void 0 ? void 0 : _response3$data.eventMessage : {};
      dispatch({
        type: 'serverErrorReducer/initServerError',
        payload: response
      });
    } else {
      var _response$data4;
      await toggleLoaderFunc(`Reviewing ${frmType} Form...`, 1000);
      response = await index.reviewJob(`SUBMIT_FORM_${window.shipmentCountry}`, {
        shipmentId: shipId,
        formType
      });
      let eventMessage = (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.eventMessage;
      fieldMessage = (eventMessage === null || eventMessage === void 0 ? void 0 : eventMessage.fieldMessage) || (eventMessage === null || eventMessage === void 0 ? void 0 : eventMessage.fieldmessage) || [];
      reviewFailedErrors = fieldMessage.filter(item => {
        return item.fieldmessagetype === 'FAIL' || item.fieldMessageType === 'FAIL';
      });
      dispatch(index.setServerErrors(fieldMessage));
    }
    if ((_reviewFailedErrors = reviewFailedErrors) !== null && _reviewFailedErrors !== void 0 && _reviewFailedErrors.length) {
      await toggleLoaderFunc('Form Reviewing failed!!', 1000);
    } else {
      await toggleLoaderFunc(`${formType} Form Reviewed succeed!!`, 1000);
      await props.setReviewSuccessfully();
      if (props.currentEntryState.includes('AMEND')) {
        await index.updateWorkFlow(shipId, 'ENTRY_AMEND_READY', brokerGuid);
      }
      if (props.currentEntryState.includes('SUP')) {
        await index.updateWorkFlow(shipId, 'ENTRY_SUP_READY', brokerGuid);
      }
      if (props.currentEntryState.includes('EXT')) {
        await index.updateWorkFlow(shipId, 'ENTRY_EXT_READY', brokerGuid);
      }
      if (props.currentEntryState.includes('RFI')) {
        await index.updateWorkFlow(shipId.split('-C-')[0], 'ENTRY_RFI_READY', brokerGuid);
      } else await index.updateWorkFlow(shipId, 'ENTRY_READY', brokerGuid);
      let pdfType, signDate, countryCode;
      countryCode = window.shipmentCountry;
      const countryConfig = index.configuration[window.shipmentCountry];
      if (countryConfig && window.shipmentCountry !== 'GB') {
        if (!countryConfig.SKIP_PDF && (!countryConfig.shouldGeneratePDF || countryConfig.shouldGeneratePDF({
          version,
          transmissionType
        }))) {
          var _pdfEu$data, _pdfEu$data$eventMess;
          if (window.shipmentCountry === 'GB') {
            pdfType = 'CLIENT_PDF_CDS_UK';
          } else if (window.shipmentCountry === 'NL') {
            pdfType = 'CLIENT_PDF_EAD_EU';
            if (version === 'DMS') {
              pdfType = isImportShipment ? 'CLIENT_PDF_DMS_IMPORT' : 'CLIENT_PDF_DMS_EXPORT';
              countryCode = isImportShipment ? 'nl-dms-import' : 'nl-dms-export';
            }
          } else if (window.shipmentCountry === 'ES') {
            pdfType = 'CLIENT_PDF_SAD_EU';
            if (version === 'AES') {
              pdfType = 'CLIENT_PDF_AES_NEW';
            }
          }
          await toggleLoaderFunc(`Generating ${frmType} document...`, 5000);
          signDate = Date.now();
          const euPdfResult = index.generatePDF(shipId, pdfType, signDate, countryCode);
          const pdfEu = await euPdfResult;
          let pdfUrl = (pdfEu === null || pdfEu === void 0 ? void 0 : (_pdfEu$data = pdfEu.data) === null || _pdfEu$data === void 0 ? void 0 : (_pdfEu$data$eventMess = _pdfEu$data.eventMessage) === null || _pdfEu$data$eventMess === void 0 ? void 0 : _pdfEu$data$eventMess.url) || '';
          props.handleFinalReviewClick(null, null, false, null, pdfUrl); //handleGeneratePdf = false
        } else {
          props.handleFinalReviewClick(null, null, false, null, null);
        }
      }
    }
  };
  const messageList = msg => {
    console.log(msg);
    return /*#__PURE__*/React__default["default"].createElement("div", null, msg.map(item => {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          "marginBottom": "10px"
        }
      }, item);
    }));
  };
  const handleReview = async (shipId, formType, msg, onCanelClicked) => {
    index$2.lib_1({
      title: "Warning",
      message: msg,
      buttons: [{
        label: 'CANCEL',
        onClick: () => {
          onCanelClicked && onCanelClicked();
          return false;
        }
      }, {
        label: 'OK',
        onClick: async () => {
          await reviewClickHandler(shipId, formType);
        }
      }]
    });
  };
  let msg = props === null || props === void 0 ? void 0 : props.alertMessages;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    id: "reviewBtn",
    size: "mini",
    key: "REVIEW",
    disabled: false,
    className: "sv todo-button secondaryBtn",
    onClick: e => {
      var _msg;
      e.stopPropagation();
      if (window.shipmentCountry == 'NL' && (props === null || props === void 0 ? void 0 : props.transmissionType) == 'CRE') {
        msg = `Did you prorate? Are you sure to you want to review this shipment?`;
        handleReview(shipId, formType, msg, () => {
          document.getElementById(`valueBuildUpTab`).click();
        });
      } else if (window.shipmentCountry === 'GB' && (_msg = msg) !== null && _msg !== void 0 && _msg.length) {
        let msgList = messageList(msg);
        handleReview(shipId, formType, msgList);
      } else {
        reviewClickHandler(shipId, formType);
      }
    }
  }, translate('REVIEW', {
    ns: ['default']
  }));
};

function ReturnToEditButton(props) {
  var _props$kxUser, _props$kxUser$userBas;
  const shipId = props.shipId;
  const brokerGuid = (_props$kxUser = props.kxUser) === null || _props$kxUser === void 0 ? void 0 : (_props$kxUser$userBas = _props$kxUser.userBasicInfo) === null || _props$kxUser$userBas === void 0 ? void 0 : _props$kxUser$userBas.userGuid;
  const returnToEditTansit = async () => {
    props.toggleLoaderFunc();
    {
      `FILE ${props.formType ? props.formType.toUpperCase() : ""}`;
    }
    await index.updateWorkFlow(shipId, "ENTRY_IN_PROCESS", brokerGuid);
    await props.toggleLoaderFunc("Please wait!!");
    document.getElementById(`card-${shipId}`) && document.getElementById(`card-${shipId}`).click();
  };
  const {
    translate
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    size: "mini",
    key: "RETURN_ES",
    disabled: false,
    className: "sv todo-button primaryBtn",
    onClick: e => {
      e.stopPropagation();
      returnToEditTansit();
    }
  }, translate("RTN_TO_EDIT").toUpperCase());
}

const FileEntryButton = props => {
  var _props$kxUser, _props$kxUser$userBas, _props$currentJobData;
  const [isMockRequest, setMockRequest] = React.useState(false);
  const shipId = props.shipId;
  (_props$kxUser = props.kxUser) === null || _props$kxUser === void 0 ? void 0 : (_props$kxUser$userBas = _props$kxUser.userBasicInfo) === null || _props$kxUser$userBas === void 0 ? void 0 : _props$kxUser$userBas.userGuid;
  const islegalNoteAccepted = props.legalAcknowledgementAccepted;
  const formType = props.formType;
  const {
    translate,
    version
  } = props;
  const country = (_props$currentJobData = props.currentJobData) === null || _props$currentJobData === void 0 ? void 0 : _props$currentJobData.countryCode;
  const enableButton = index.configuration[country]['SKIP_PDF'];
  const fileClickHandler = async () => {
    var _res$data, _res$data$eventMessag, _res$data2, _res$data2$eventMessa;
    await props.toggleLoaderFunc("Filing in process...");
    let payload = {
      shipmentId: shipId,
      language: window.shipmentCountry.toLowerCase(),
      countryCode: window.shipmentCountry.toLowerCase(),
      version: version,
      mockRequest: !isMockRequest,
      formType: formType,
      eventType: `FILE_FORM_${window.shipmentCountry}`,
      reason: null
    };
    if (props.lowerEnv[0] === 'prod') {
      payload.mockRequest = false;
    }
    if (window.shipmentCountry === "GB") {
      delete payload.language;
      payload.countryCode = "GB";
    }
    const res = await index.fileJob(payload);
    await props.toggleLoaderFunc("Filing in process...");
    let msg = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$eventMessag = _res$data.eventMessage) === null || _res$data$eventMessag === void 0 ? void 0 : _res$data$eventMessag.msg;
    if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$eventMessa = _res$data2.eventMessage) === null || _res$data2$eventMessa === void 0 ? void 0 : _res$data2$eventMessa.code) == 400) {
      props.toggleLoaderFunc(`Filing failed: ${msg}.`, 6000, "red");
      index.showToast(msg, 6000);
      setTimeout(() => {
        props.searchByID(shipId);
      }, 3000);
    } else {
      props.toggleLoaderFunc(msg);
      //await props.searchByID(shipId)
      document.getElementById(`card-${shipId}`).click();
    }
    // await props.toggleLoaderFunc("Please Wait...");
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button.Group, null, /*#__PURE__*/React__default["default"].createElement(ReturnToEditButton, props), props.lowerEnv[0] !== 'prod' && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
    key: "uatFiling",
    id: "returnToEdit",
    className: "fileWithES",
    checked: isMockRequest,
    label: `FILE WITH SANDBOX`,
    translate: translate,
    onChange: event => {
      let chk = event.target.checked ? true : false;
      setMockRequest(chk);
    }
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    size: "mini",
    key: "FILE",
    disabled: !islegalNoteAccepted && !enableButton,
    className: "sv todo-button secondaryBtn",
    onClick: e => {
      e.stopPropagation();
      fileClickHandler();
    }
  }, translate("FILE", {
    ns: ["default"]
  }), " ", (props === null || props === void 0 ? void 0 : props.buttonLabel) && translate(props === null || props === void 0 ? void 0 : props.buttonLabel, {
    ns: ["default"]
  })));
};

const updateEntry = props => {
  var _props$kxUser, _props$kxUser$userBas;
  const {
    shipId,
    EntryState,
    transmissionType,
    label
  } = props;
  const brokerGuid = (_props$kxUser = props.kxUser) === null || _props$kxUser === void 0 ? void 0 : (_props$kxUser$userBas = _props$kxUser.userBasicInfo) === null || _props$kxUser$userBas === void 0 ? void 0 : _props$kxUser$userBas.userGuid;
  const updateClickHandler = async () => {
    index$2.lib_1({
      message: `Are you sure to ${label || 'Update'} this shipment?`,
      buttons: [{
        label: 'CANCEL',
        onClick: () => {
          return false;
        }
      }, {
        label: 'OK',
        onClick: async () => {
          await props.toggleLoaderFunc();
          if (EntryState === 'STATE_ENTRY_FILED' && label === "RESET") {
            await index.updateWorkFlow(shipId, "ENTRY_IN_PROCESS", brokerGuid);
          }
          if (EntryState === 'STATE_ENTRY_SUP_FILED' && label === "RESET") {
            await index.updateWorkFlow(shipId, "ENTRY_SUP_IN_PROCESS", brokerGuid);
          }
          if (EntryState === 'STATE_ENTRY_EXT_FILED' && label === "RESET") {
            await index.updateWorkFlow(shipId, "ENTRY_EXT_IN_PROCESS", brokerGuid);
          } else if (EntryState === 'STATE_ENTRY_AMEND_FILED' && label === "RESET") {
            await index.updateWorkFlow(shipId, "ENTRY_AMEND_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_CANCELLED_FILED" && label === "RESET") {
            await index.updateWorkFlow(shipId, "ENTRY_ACCEPTED", brokerGuid);
          } else if (["STATE_ENTRY_CANCELLED_FAILED", "STATE_ENTRY_AMEND_IN_PROCESS", "STATE_ENTRY_AMEND_READY"].includes(EntryState)) {
            await index.updateWorkFlow(shipId, "ENTRY_ACCEPTED", brokerGuid);
          } else if (["STATE_ENTRY_ACCEPTED", "STATE_ENTRY_AMEND_ACCEPTED", "STATE_ENTRY_RELEASED"].includes(EntryState) && transmissionType == "EXT") {
            await index.updateWorkFlow(shipId, "ENTRY_EXT_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_ACCEPTED" && transmissionType == "COR") {
            await index.updateWorkFlow(shipId, "ENTRY_AMEND_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_RELEASED" && transmissionType == "SUP") {
            await index.updateWorkFlow(shipId, "ENTRY_SUP_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_SUP_REJECTED" && transmissionType == "SUP") {
            await index.updateWorkFlow(shipId, "ENTRY_SUP_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_EXT_REJECTED" && transmissionType == "EXT") {
            await index.updateWorkFlow(shipId, "ENTRY_EXT_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_AMEND_ACCEPTED" && (label === "UPDATE" || label === "AMEND")) {
            await index.updateWorkFlow(shipId, "ENTRY_AMEND_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_AMEND_REJECTED" && (!label || label === "UPDATE" || label === "AMEND")) {
            await index.updateWorkFlow(shipId, "ENTRY_AMEND_IN_PROCESS", brokerGuid);
          } else if ((EntryState === "STATE_ENTRY_ACCEPTED" || EntryState === "STATE_ENTRY_CLEARED") && label === "AMEND") {
            await index.updateWorkFlow(shipId, "ENTRY_AMEND_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_AMEND_FAILED" && label === "AMEND") {
            await index.updateWorkFlow(shipId, "ENTRY_AMEND_IN_PROCESS", brokerGuid);
          } else if (EntryState === "STATE_ENTRY_RFI_REJECTED" && label === "UPDATE") {
            await index.updateWorkFlow(shipId, "ENTRY_RFI_IN_PROCESS", brokerGuid);
          } else {
            await index.updateWorkFlow(shipId, "ENTRY_IN_PROCESS", brokerGuid);
          }
          await props.toggleLoaderFunc("Please wait!!");
          //props.searchByID(shipId)
          document.getElementById(`card-${shipId}`).click();
        }
      }]
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    id: props.label,
    size: "mini",
    key: "UPDATE ES",
    disabled: false,
    className: "sv todo-button primaryBtn",
    onClick: e => {
      e.stopPropagation();
      updateClickHandler();
    }
  }, props.label ? props.label : `UPDATE`);
};

exports.BackToPoolButton = BackToPoolButton;
exports.ExpandCollapseButton = ExpandCollapseButton;
exports.FileEntryButton = FileEntryButton;
exports.ReturnToEditButton = ReturnToEditButton;
exports.ReviewEntryButton = ReviewEntryButton;
exports.TakeOverButton = TakeOverButton;
exports.updateEntry = updateEntry;
//# sourceMappingURL=updateEntry-78f4432e.js.map
